module.exports = __webpack_public_path__ + "img/only-private-internal.094109e0.svg";